const resource = {
    resource_identifier_in_use: "L'identifiant d'API {{indicator}} est déjà utilisé",
    cannot_delete_management_api: "Impossible de supprimer l'API de gestion de Logto.",
    cannot_modify_management_api: "Impossible de modifier l'API de gestion de Logto.",
};
export default Object.freeze(resource);
